import React from 'react'

const withEventHandlers = WrappedComponent => {
  return props => {
    const { setModal } = props // via withRedux

    const handleApply = () => {
      setModal({ open: true, id: 'FinancialAidApplication' })
    }

    return <WrappedComponent onApply={handleApply} {...props} />
  }
}

export default withEventHandlers
